import styles from './index.module.scss'
import PictureResultItem from '../../components/PictureResultItem'
import PictureViewModal from '../../components/PictureViewModal'
import React, { forwardRef, useContext, useEffect, useRef, useState, useImperativeHandle } from 'react';
import { useProjectGroupedTasks } from '@view/page_v3/hooks/ProjectDetailSort'
import ProjectDetailGroupsTitle from '@view/page_v3/components/ProjectDetailGroupsTitle'
import { DISPLAY_TYPE, IMAGE_TYPE } from '@utils/CONST'
import { AppContext } from '@utils/AppContext';
import { Button, message, Modal } from 'antd';
import { workflowOfLoadTaskInfo, workflowOfReGenerate } from '@utils/workflowOfBuildTaskV2';
import { useNavigate } from 'react-router-dom';
import { CloseOutlined } from '@ant-design/icons';
import { GenerateContext } from '../../hooks/GenerateContext'


const GenerateResults = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        fetchProjectDetail
    }))

    const modalRef = useRef()
    const { projectId } = props
    const { setGlobalTaskReadFlag } = useContext(AppContext)
    const { setProjectId, imageType } = useContext(GenerateContext)
    const navigate = useNavigate()

    const { groupedTasks, rawTasks, fetchProjectDetail } = useProjectGroupedTasks(projectId)

    const [recreateLoading, setRecreateLoading] = useState({})
    const createAgain = async (item1, groupIndex) => {
        const succeededItem = item1.find(item => item.status === "succeeded") || item1.find(item => item.status == "failed");
        if (succeededItem) {
            try {
                setRecreateLoading(prev => ({ ...prev, [groupIndex]: true }))
                const taskID = succeededItem.taskId
                const res = await workflowOfReGenerate(succeededItem.imageType, taskID)
                if (!res) return
                const { disabled, pathname, options } = res
                if (disabled) {
                    message.warning("版本更新，请重新编辑后再重新生成")
                    navigate(pathname, options)
                } else {
                    message.success('生成中，请稍后！')
                    setGlobalTaskReadFlag(prev => !prev)
                    fetchProjectDetail()
                }
            } catch (err) {
                message.warning(err.message)
            } finally {
                setRecreateLoading(prev => ({ ...prev, [groupIndex]: false }))
            }
        } else {
            message.warning('请先等待生成成功后再重新生成')
        }
    }

    const [rebuildLoading, setRebuildLoading] = useState({})
    const rebuildClick = async (item1, groupIndex, commidityOldDataRebuild) => {
        const succeededItem = item1.find(item => item.status === "succeeded") || item1.find(item => item.status === "failed")
        if (succeededItem) {
            try {
                setRebuildLoading(prev => ({ ...prev, [groupIndex]: true }))
                const res = await workflowOfLoadTaskInfo(succeededItem.imageType, succeededItem.taskId, commidityOldDataRebuild)
                if (!res) return
                const { pathname, options } = res
                navigate(pathname, options)
            } catch (err) {
                message.warning(err.message)
            } finally {
                setRebuildLoading(prev => ({ ...prev, [groupIndex]: false }))
            }
        } else {
            message.warning('请先等待生成成功后再重新编辑')
        }
    }

    // 大图弹窗
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [item, setItem] = useState()
    const [taskId, setTaskId] = useState()
    const [modalOpenFlag, setModalOpenFlag] = useState(false)
    useEffect(() => {
        if (!isModalOpen) {
            setTaskId()
            setItem()
        }
    }, [isModalOpen])
    const handleCLick = (item) => {
        if (item.status != "succeeded") return
        setItem(item)
        setTaskId(item?.taskId)
    }
    useEffect(() => {
        if (item && taskId) {
            setIsModalOpen(true)
        }
    }, [item, taskId])


    return (
        <>
            <div className={`${styles.GenerateResults} _beauty_scrollbar`}>
                {
                    groupedTasks.map((item1, index) => {
                        return <React.Fragment key={index}>
                            <div className={styles.Title}>
                                <ProjectDetailGroupsTitle
                                    item={item1[0]}
                                    imageType={item1[0]?.imageType}
                                />
                                <>
                                    <Button style={{ width: 120, height: 32, marginRight: 12 }} loading={rebuildLoading[index]} onClick={() => rebuildClick(item1, index)}>重新编辑</Button>
                                    <Button style={{ width: 120, height: 32 }} loading={recreateLoading[index]} onClick={() => {
                                        // 商品旧数据直接跳到重新编辑
                                        if (item1?.[0]?.imageType === IMAGE_TYPE.COMMODITY && item1?.[0]?.version !== 'V3.8.20251127') {
                                            rebuildClick(item1, index, true)
                                        } else createAgain(item1, index)
                                    }}>再次生成</Button>
                                </>
                            </div>
                            {
                                item1?.map((item2) => (
                                    <div
                                        key={item2.taskId}
                                        className={styles.ContentItem}
                                    >
                                        <PictureResultItem
                                            displayType={DISPLAY_TYPE.GENERATE}
                                            setProjectId={setProjectId}
                                            item={item2}
                                            imageType={item2?.imageType}
                                            handleCLick={() => handleCLick(item2)}
                                            isSelected={false}
                                            selectedList={[]}
                                            rawTasks={rawTasks}
                                            selectCurrentItem={null}
                                            fetchProjectDetail={fetchProjectDetail}
                                        />
                                    </div>
                                ))
                            }
                            <p style={{ marginBottom: '50px', width: '100%' }}></p>
                        </React.Fragment>
                    })
                }

            </div>
            <p className={`${styles.Footer} ${imageType == IMAGE_TYPE.FUSION_WEAR ? styles.FooterFusionWear : ''} ${imageType == IMAGE_TYPE.CREATIVE_IMAGE_GEN ? styles.FooterCentered : ''}`}>以上内容由人工智能模型生成，不代表平台的观点、立场或态度，请合理友善地使用生成内容</p>
            <Modal
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                footer={null}
                maskClosable={true}
                width="100%"
                style={{ top: 0, padding: 0, margin: 0, maxWidth: '100vw', height: '100vh' }}
                bodyStyle={{ height: '100vh', overflow: 'hidden' }}
                destroyOnHidden
                onCancel={() => setIsModalOpen(false)}
                className={styles.PictureViewModal}
                afterOpenChange={(open) => setModalOpenFlag(open)}
                closeIcon={false}
            >
                <PictureViewModal
                    modalOpenFlag={modalOpenFlag}
                    displayType={DISPLAY_TYPE.GENERATE}
                    setProjectId={setProjectId}
                    ref={modalRef}
                    taskId={taskId}
                    setTaskId={setTaskId}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    item={item}
                    setItem={setItem}
                    groupedTasks={groupedTasks}
                    fetchProjectDetail={fetchProjectDetail} />
            </Modal>
        </>

    )
})

export default GenerateResults
